<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <a class="mr-3 back-icon" @click="$router.push({ path: '/app/service-audits' })">
                <i class="material-icons">keyboard_backspace</i>
              </a>
            </div>
            <div class="col s10 m6 m6 alignRight">
              <div v-if="isCancelAudit()" class="cancel-bloc">
                <a @click="preCancel()" class="btn">Cancel</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 35px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div id="responsive-table" class="card card card-default scrollspy mb-0 h-100">
                  <div class="card-content h-100" style="overflow:auto">
                    <div class="row">
                      <div class="col s9 m9 l9">
                        <h4 class="card-title alignLeft">#{{auditDetail.uid}}</h4>
                      </div>
                      <div class="col s3 m3 l3">
                        <div class="assignee-block">
                          <div class="assignee-title">Assignee</div>
                          <div class="assignee" v-if="auditDetail.vendor">
                            <b>{{auditDetail.vendor ? auditDetail.vendor.first_name : ""}} ({{auditDetail.vendor ? auditDetail.vendor.rep_id : ""}})</b>
                          </div>
                          <div class="assignee" v-if="!auditDetail.vendor">No one</div>
                          <i
                            v-if="!auditDetail.vendor && isCancelAudit()"
                            @click="openAssignees($event)"
                            class="material-icons a-settings"
                          >settings</i>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col s12 m12 l12">
                        <div class="header-sec">
                          <div class="details">
                            <!-- <span
                              v-if="auditDetail.vendor"
                              class="name"
                            >{{auditDetail.vendor ? auditDetail.vendor.first_name : ""}}({{auditDetail.vendor ? auditDetail.vendor.rep_id : ""}})</span>-->
                            <span
                              v-if="auditDetail.user"
                              :class="{'p0' : !auditDetail.user}"
                              class="createdby"
                            >Booked by {{auditDetail.user ? auditDetail.user.first_name : ""}}</span>
                            <span class="divider-line">|</span>
                            <span
                              class="classtag"
                            >{{auditDetail.created_at | date('D MMM YYYY')}}</span>
                          </div>
                          <div class="label-status">
                            <span class="prioritytag">{{auditDetail.service}}</span>
                            <span
                              v-if="auditDetail.dates"
                              :class="getClassName"
                            >{{auditDetail.dates ? (auditDetail.dates.status ? auditDetail.dates.status.name : "") : ""}}</span>
                          </div>
                        </div>
                        <div class="body-sec">
                          <div class="issue-track-items bg-track-odd1">
                            <div class="desc">
                              <div class="desc-block">
                                <div class="title-cd">Estimation Cost:</div>
                                <div class="value-cd">Rs.{{auditDetail.expected_cost}}</div>
                              </div>
                              <div class="desc-block">
                                <div class="title-cd">Audit Date & Time:</div>
                                <div
                                  v-if="auditDetail.dates"
                                  class="value-cd"
                                >{{(auditDetail.dates.date + ' ' + auditDetail.dates.time) | date('D MMM YYYY hh:mm A')}}</div>
                              </div>
                              <div class="desc-block">
                                <div class="title-cd">Audit Address:</div>
                                <div
                                  class="value-cd"
                                  v-if="auditDetail.address "
                                >{{auditDetail.address.line1 + (auditDetail.address.line2 ? ", " + auditDetail.address.line2 : '') + ", " + auditDetail.address.city + ", " + auditDetail.address.state + " - " + auditDetail.address.postcode}}</div>
                              </div>
                              <div class="desc-block" v-if="auditDetail.additional_info">
                                <div class="title-cd">Additional Info:</div>
                                <div class="value-cd">{{auditDetail.additional_info}}</div>
                              </div>
                              <div
                                class="desc-block s-req"
                                v-if="auditDetail.info && auditDetail.info.length>0"
                              >
                                <div class="title-cd">Service Requirements:</div>
                                <div
                                  class="ques-list"
                                  v-for="(que,index) in auditDetail.info"
                                  :key="que.id"
                                >
                                  <div class="ques">
                                    <span>{{index + 1}})</span>
                                    {{que.label}}
                                  </div>
                                  <div class="answr">{{que.value}}</div>
                                </div>
                              </div>
                              <br />
                              <div
                                class="desc-block s-req"
                                v-if="auditDetail.images && auditDetail.images.length>0"
                              >
                                <div class="title-cd">Audit Images</div>
                                <div
                                  @click="open(index)"
                                  class="image-list"
                                  v-for="(img,index) in auditDetail.images"
                                  :key="img.id"
                                >
                                  <div class="image">
                                    <img :src="img.image" alt />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="image-slider">
      <div class="bg-slider-block"></div>
      <div class="close-btn nav-btns" @click="close()">
        <i class="material-icons">close</i>
      </div>
      <div class="prev-btn nav-btns" @click="prev()">
        <i class="material-icons">arrow_backward</i>
      </div>
      <div class="next-btn nav-btns" @click="next()">
        <i class="material-icons">arrow_forward</i>
      </div>
      <div class="fullimage">
        <div class="carousel carousel-slider">
          <a class="carousel-item" v-for="img in auditDetail.images" :key="img.id">
            <img class="activator" :src="img.image" alt />
          </a>
        </div>
      </div>
    </div>
    <div class="assignees-list">
      <div class="input-search-box search-input">
        <div class="search-area">
          <i class="material-icons mr-2 search-icon">search</i>
          <input
            type="text"
            placeholder="Search assignees"
            id="assignee_filter"
            class="app-filter assignee_filter"
          />
        </div>
      </div>
      <div class="list-opts">
        <div class="loader" v-if="assigneeLoader">
          <svg
            version="1.1"
            id="L9"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            enable-background="new 0 0 0 0"
            xml:space="preserve"
          >
            <path
              fill="#cdefd0"
              d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
            >
              <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="rotate"
                dur="1s"
                from="0 50 50"
                to="360 50 50"
                repeatCount="indefinite"
              />
            </path>
          </svg>
        </div>
        <div class="assingee-block" v-if="!assigneeLoader">
          <div v-if="assigneeList.length==0" class="assignees-list-items">
            <div class="uname center-align">No Vendors found</div>
          </div>
          <div
            class="assignees-list-items"
            @click="selectAssignee(assignee)"
            v-for="(assignee,index) in assigneeList"
            :key="index"
          >
            <!-- <div class="usr-img"><img v-if="assignee.vendor.profile_pic" :src="assignee.vendor.profile_pic" alt=""></div> -->
            <div class="usr-img">{{assignee.vendor.short_name}}</div>
            <div class="uname">{{assignee.vendor.first_name}}</div>
            <div
              class="fullname"
              v-if="assignee.vendor"
            >{{assignee.vendor ? (assignee.vendor.rep_id + ",") : ""}}</div>
            <div class="distance">{{assignee.distance | number}} km away</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoader: true,
      assigneeLoader: false,
      assigneeList: [],
      auditDetail: {
        dates: {
          status: {
            code: ""
          }
        }
      },
      carousel: {},
      auditNo: this.$route.params.id
    };
  },
  created() {
    this.retrieveAudit();
    this.listAssignees();
    setTimeout(() => {
      $("html")
        .off()
        .on("click", function(e) {
          if (
            !$(e.target).hasClass("a-settings") &&
            !$(e.target).hasClass("assignee_filter")
          ) {
            $(".assignees-list").removeClass("show-assignee");
          }
        });
    }, 500);
  },
  computed: {
    getClassName() {
      if (this.auditDetail.dates.status) {
        let className = "";
        if (this.auditDetail.dates.status.name) {
          if (this.auditDetail.dates.status.name.indexOf("Booked") != -1)
            className = "open";
          else if (
            this.auditDetail.dates.status.name.indexOf("Started") != -1
          )
            className = "inprogress";
          else if (
            this.auditDetail.dates.status.name.indexOf("Completed") != -1
          )
            className = "completed";
          else className = "failed";
        }
        return "statustag " + className;
      } else return "statustag";
    }
  },
  methods: {
    initSlider() {
      setTimeout(() => {
        this.carousel = $(".carousel").carousel({
          // fullWidth: true,
          indicators: true,
          noWrap: true,
          duration: 150
        });
      }, 500);
    },
    retrieveAudit() {
      this.isLoader = true;
      ajax.get(
        Constants.default.APIURL.RetrieveAudit + this.auditNo,
        res => {
          this.auditDetail = res.data;
          this.isLoader = false;
          this.initSlider();
        },
        err => {
          this.isLoader = false;
        }
      );
    },
    openAssignees(ev) {
      var top = $(ev.target).offset().top + 30;
      var left = $(ev.target).offset().left - 400;
      $(".assignees-list").addClass("show-assignee");
      $(".assignees-list").css("top", top + "px");
      $(".assignees-list").css("left", left + "px");
    },
    listAssignees() {
      this.assigneeLoader = true;
      return new Promise(resolve => {
        ajax.get(
          Constants.default.APIURL.RelatedVendors + this.auditNo,
          res => {
            this.assigneeList = res.data;
            this.assigneeLoader = false;
            resolve(true);
          },
          err => {
            this.assigneeLoader = false;
            resolve(false);
          }
        );
      });
    },
    selectAssignee(assignee) {
      let query = {
        vendor: assignee.vendor.id
      };
      ajax.patch(
        Constants.default.APIURL.AssignVendor + this.auditNo,
        query,
        res => {
          Vue.toast("Audit has been assigned successfully.");
          this.retrieveAudit();
        },
        err => {
          Vue.toast("", err);
        }
      );
    },
    preCancel() {
      swal({
        title: "Are you sure?",
        text: `This action is irreversible. Do you want to to cancel this audit?`,
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: "No",
          delete: "Yes"
        }
      }).then(willDelete => {
        console.log(willDelete);
        if (willDelete) {
          this.cancelAudit();
        }
      });
    },
    cancelAudit() {
      ajax.put(
        Constants.default.APIURL.CancelAudit + this.auditNo,
        {},
        res => {
          Vue.toast("Audit has been cancelled successfully.");
          this.retrieveAudit();
        },
        err => {
          Vue.toast("", err);
        }
      );
    },
    isCancelAudit() {
      let isCancel =
        this.auditDetail.dates.status.code == "audit_started" ||
        this.auditDetail.dates.status.code == "audit_completed" ||
        this.auditDetail.dates.status.code == "audit_cancelled" ||
        this.auditDetail.dates.status.code == "payment_failed" ||
        this.auditDetail.dates.status.code == "admin_audit_cancelled";
      return !isCancel;
    }
  }
};
</script>
<style <style lang="scss" scoped>
h5 {
  font-size: 1.5rem;
}
.assignee-block {
  position: relative;
  text-align: left;
  .assignee-title {
    font-weight: 500;
  }
  .assignee {
    font-size: 14px;
    color: rgba(24, 50, 71, 0.6);
  }
  i {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    font-size: 18px;
    perspective-origin: 1000px;
    cursor: pointer;
  }
}

.assignees-list {
  border-radius: 3px;
  border: 1px solid gainsboro;
  padding: 0px;
  max-height: 0;
  transition: 0.3s ease-in-out;
  opacity: 0;
  min-width: 300px;
  z-index: 99999999;
  perspective: 1000px;
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  .list-opts {
    min-height: 100px;
    .loader {
      svg {
        width: 100px;
      }
    }
  }
  .input-search-box {
    padding: 10px;
    position: sticky;
    top: 0;
    background: white;
  }
  .assignees-list-items {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: flex-start;
    padding: 5px 10px 0px 10px;
    border-bottom: 1px solid #f1eded;
    div {
      margin: 5px;
      padding: 0px;
    }
    .usr-img {
      width: 30px;
      height: 30px;
      border-radius: 5px;
      background: #efe7e7;
    }

    .uname {
      font-weight: 600;
    }
  }
}

.show-assignee {
  max-height: 400px;
  min-width: 400px;
  opacity: 1;
}

.card .card-title {
  font-size: 20px !important;
}
.header-sec {
  text-align: left;
  .details {
    font-size: 14px;
    position: relative;
    .name {
      font-weight: 600;
      padding-right: 10px;
    }
    .divider-line {
      color: gainsboro;
      font-weight: 500;
      font-size: 18px;
      position: absolute;
      bottom: -2px;
    }
    .createdby {
      font-weight: 500;
      padding-right: 10px;
    }
  }
  .label-status {
    display: block;
    margin-bottom: 3px;
    margin-top: 10px;
    .cancel-bloc {
      float: right;
      margin-top: -10px;
    }
  }
  .classtag {
    font-size: 13px;
    margin-left: 15px;
  }
  .prioritytag {
    border: 1px solid gainsboro;
    padding: 2px 8px;
    border-radius: 5px;
    font-size: 13px;
  }

  .statustag {
    border: 1px solid #ff5a5a;
    padding: 2px 8px;
    border-radius: 5px;
    font-size: 13px;
    margin-left: 15px;
    background: #ff5a5a;
    color: #ffffff;
    font-weight: 500;
    &.inprogress {
      background: #0099ff;
      border-color: #0099ff;
    }
    &.completed {
      background: #3fa93a;
      border-color: #3fa93a;
    }
    &.failed {
      background: #e48b22;
      border-color: #e48b22;
    }
  }
}
.body-sec {
  text-align: left;
  margin-top: 30px;
  .issue-track-items {
    border-radius: 4px;
    margin: 10px 0;
    display: flex;
    .desc {
      width: 100%;
      text-align: left;
      text-transform: capitalize;
      .s-req {
        display: block !important;
        .ques {
          padding: 2px 15px;
          font-weight: 500;
          font-size: 14px;
          span {
            padding-right: 8px;
          }
        }

        .answr {
          padding: 0 40px;
          font-weight: 600;
          font-size: 14px;
        }
      }
      .desc-block {
        display: flex;
        .title-cd {
          padding: 5px;
          font-weight: 600;
          font-size: 14px;
        }
        .value-cd {
          padding: 5px;
          font-weight: 500;
          font-size: 14px;
        }
      }
      .image-list {
        display: inline-block;
        cursor: pointer;
        .image {
          padding: 0px;
          margin: 10px;
          width: 100px;
          height: 100px;
          border-radius: 5px;
          img {
            border-radius: 5px;
            width: 100%;
            height: 100%;
            object-fit: fill;
          }
        }
      }
    }
  }
}

.bg-track-odd {
  background: rgb(245, 247, 249) !important;
}

.p0 {
  padding: 0 !important;
  padding-left: 0 !important;
}
</style>

